module.exports = __webpack_public_path__ + "img/insta.icon.e3f97221.svg";